export enum ExternalAccountType {
    QuickBooks = 1,
    Xero = 2,
    Sage = 3,
}